export default {
  sales: "Sales",
};
